import React, { useState, useEffect } from "react";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Typography from "@material-ui/core/Typography";
import Box from "@material-ui/core/Box";
import {Grid,Card,
  CardContent} from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import GlobalApi from "../../../Global";
import refresh_token from "../../../Global/refresh_token";
import "../analytic.css";
import DateFnsUtils from "@date-io/date-fns"; // choose your lib
import Tooltip from "@material-ui/core/Tooltip";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import Progress from "react-circle-progress-bar";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import Fab from "@material-ui/core/Fab";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import Select from "@material-ui/core/Select";
import Link from "@material-ui/core/Link";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import TableRow from "@material-ui/core/TableRow";
import ArrowDownwardIcon from "@material-ui/icons/ArrowDownward";
import ArrowUpwardIcon from "@material-ui/icons/ArrowUpward";
import Brightness1Icon from "@material-ui/icons/Brightness1";

import { makeStyles, withStyles } from "@material-ui/core/styles";
import InspectionAction from "./inspectionAction";
import { saveAs } from "file-saver";
import useDimensions from "../../../Global/useDimensions";
import SearchIcon from "@material-ui/icons/Search";
import { useHistory } from "react-router-dom";
import { useTheme } from "@material-ui/core/styles";
import DarkButton from "../../../Global/DarkButton";

import useMediaQuery from "@material-ui/core/useMediaQuery";

import ButtonGroup from "@material-ui/core/ButtonGroup";
import moment from "moment";
import swal from "@sweetalert/with-react";
import _, { filter } from "lodash";
import Chart from "react-google-charts";
import Color from "../../../Global/colors";

// import DarkButton from "./../../Global/DarkButton";
import Spinner from "../../../Global/Spinner";
import { SearchBar } from "../Dashboard/SearchBar";
import { TabBar } from "../Dashboard/TabBar";

import calender_img from "../Assets/performance_calendar.png";
import Dialog from "@material-ui/core/Dialog";
import { useSelector, useDispatch } from "react-redux";
import CloseIcon from "@material-ui/icons/Close";
import {useTranslation} from 'react-i18next';

export default function ActionAnalytics() {
  const {t} = useTranslation();
  const history = useHistory();
  const { width } = useDimensions();

  const [value, setValues] = React.useState({
    from: moment()
      .subtract(9, "days")
      .toDate(),
    end: new Date(),
    custom_selected: "",
  });
  const [btnLoader, setBtnLoader] = React.useState(false)
  const [downloadIndex, setDownloadIndex] = React.useState(null);
  const [actionTableData, setActionTableData] = React.useState([]);

  const [templates, setTemplates] = React.useState([]);
  const [inspections, setInspections] = React.useState([]);
  const [sites, setSites] = React.useState([]);

  const [packageDetails, setPackageDetails] = React.useState(null);
  const [open, setOpen] = React.useState(false);
  const theme = useTheme();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const [openModal,setModalAction]=React.useState(false)
  let company = useSelector((state) => state.companyReducer.company);
  let companies = useSelector((state) => state.companyArrReducer.company);
  const setModal=(tab,state)=>{
    setModalAction(state)
  }

  React.useEffect(() => {
    // props.func();
    getTemplates(company.id);
    getInspections(company.id);
    getSites(company.id);
    getPackageDetails();
    setValues({
      ...value,
      company_id: company.id,
    });
  }, [company?.id]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  async function getPackageDetails() {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let package_inquiry = {
      user_id: data.user_id,
      organization_id: data.organization_id,
    };

    let query = Object.keys(package_inquiry)
      .map(
        (k) =>
          encodeURIComponent(k) + "=" + encodeURIComponent(package_inquiry[k])
      )
      .join("&");
    let req = await fetch(
      GlobalApi + "/Package/get_user_license_details?" + query,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + token,
          "Content-Type": "application/json",
        },
      }
    );

    let reqJson = await req.json();

  
    if (reqJson?.package?.license?.status === "expired" || reqJson?.package?.license?.status === "deactive") {
      history.replace("/billing");
    } else {
      setPackageDetails(reqJson.package);
    }
  }


  function getTemplates(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Template/get_all_templates?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        if (response.status === "Success") {
          setTemplates(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          // console.log(status);
          if (status) {
            getTemplates(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getInspections(currentCompany) {
    console.log("+++++++++++++++++++++++++++++++++++++Get Inspections Called")
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Schedule/get_all_schedules_organization?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log(response,"inspections**************************************");
        if (response.status === "Success") {
          await setInspections(response.data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            getInspections(currentCompany);
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  function getSites(currentCompany) {
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id: currentCompany,
    };
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Region/get_all_regions?" + query, {
      method: "get",
      headers: new Headers({
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
        Accept: "application/json",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        let arr = [];
        data.data.map((value, index) => {
          //console.log(value.title);
          value.Areas.map((area, i) => {
            area.Sites.map((sites, j) => {
              // console.log(value.title, area.title, sites.title);
              let obj = {
                title: sites.title,
                id: sites.id,
              };
              if (sites.status !== "deactivated") {
                arr.push(obj);
              }
              //console.log(obj);
              setSites(arr);
            });
            //console.log(this.state.row);
            //console.log(result.title,value.title);
          });
        });
      });
  }

  function handleSideBarChange(event) {
    // let { value, name } = event.target;

    // console.log(name, value);
    setValues({
      ...value,
      [event.target.name]: event.target.value,
    });
    if(event.target.name == "company_id"){
      console.log("event.target.value",event.target.value)
      getInspections(event.target.value);
      getSites(event.target.value);
      getTemplates(event.target.value);
      setValues({
        ...value,
        template_id:"",
        schedule_id:'',
        site_id:'',
      });
    }

  }

  async function handleSideBarSubmitAction(isMine) {
    setOpen(false);

    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      company_id:value.company_id,
      template_id: value.template_id?.id,
      schedule_id: value.schedule_id?.id,
      site_id: value.site_id?.id,
      end_date: value.end,
      from_date: value.from,
      user_id: isMine == true ? data.user_id : undefined,
    };

    console.log("PARAMS FOR GET ACTION ANALYTICS*__________________________________", params)

    // console.log(data.user_id);
    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");

    fetch(GlobalApi + "/Action/get_action_analytics?" + query, {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((responseJson) => responseJson.json())
      .then(async (response) => {
        console.log("RESPONSE FOR GET ACTION ANALYTICS*__________________________________",response)
        if (response.status === "Success") {
          let initial_data = response.data
            .map((v) => {
              if (v?.inspection_id !== null) {
                if (v?.Inspection !== null) {
                  return v;
                }
              } else {
                if (value.template_id?.id && v?.Inspection === null) {
                  return;
                } else {
                  return v;
                }
              }
            })
            .filter((v) => v !== undefined);
            setBtnLoader(false);
            setModal("action",false)
          setActionTableData(initial_data);
        } else if (
          response.error === "jwt expired" ||
          response.error === "invalid token" ||
          response.error === "invalid signature" ||
          response.error === "Unexpected token"
        ) {
          let status = await refresh_token();
          console.log(status);
          if (status) {
            handleSideBarSubmitAction();
          }
        }
      })
      .catch((error) => console.log(error.message));
  }

  const handlePdfDownload = async (inspection_id,isCompleted,pdf_url) => {
    // alert(isCompleted)
    let localstorage = localStorage.getItem("UserData");
    var data = JSON.parse(localstorage);
    let token = data.token;
    let params = {
      inspection_id,
      user_id: data.user_id,
      url: GlobalApi.replace("api", ""),
    };

    let query = Object.keys(params)
      .map((k) => encodeURIComponent(k) + "=" + encodeURIComponent(params[k]))
      .join("&");
    console.log(query);


    if (packageDetails.pdf_request_status === "Request is Valid") {
      if(isCompleted || (pdf_url !== null && pdf_url !== undefined)) {
      
        // window.open(GlobalApi + "/Inspection/create-pdf?" + query, '_blank');
        let pdfData = await fetch(GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );
        let pdfDataJson = await pdfData.json();
        console.log("pdfData", pdfDataJson.pdf_url);
        window.open(pdfDataJson.pdf_url, '_blank');
        setDownloadIndex(null);
      } else {
        let pdfData = await fetch(
          GlobalApi + "/Inspection/create-pdf?" + query,
          {
            method: "GET",
            headers: {
              Authorization: "Bearer " + token,
              "Content-Type": "application/json",
            },
          }
        );

        const blob = await pdfData.blob();

        
        // setwaitForResponseWithOverlay( false );

        // const fileURL = URL.createObjectURL( blob );
        
  
        await saveAs(blob);
     
        // await saveAs(GlobalApi + "/Inspection/create-pdf?" + query);
        setDownloadIndex(null);
      }
    } else {
      setDownloadIndex(null);

      swal(t("Warning"), packageDetails.pdf_request_status, "warning");
    }
  };

  if (packageDetails !== null) {
    return (
      <div style={{padding:'0px', display:"flex",overflow:'hidden', flexDirection:'column',backgroundColor:Color.globalColor9}}>
      <Grid className="" container style={{overflowY:'auto', border:'none', padding:'20px'}}>
        {/* <Grid item xs={12} md={12}>
          <SearchBar
            value={value}
            handleSideBarSubmit={handleSideBarSubmitAction}
            handleSideBarChange={handleSideBarChange}
            templates={templates}
            inspections={inspections}
            sites={sites}
            packageDetails={packageDetails}
            btnLoader={btnLoader}
            setBtnLoader={setBtnLoader}
          />
        </Grid> */}
        <Dialog
          onClose={()=>{setModal("action",false)}}
          aria-labelledby="max-width-dialog-title"
          open={openModal}
          fullWidth={true}
          maxWidth={"sm"}
          scroll={"paper"}
          className="executiveDashModal"
        >
          <React.Fragment>
            <Grid
              item
              xs={12}
              style={{ alignSelf: "flex-end", cursor: "pointer" }}
              onClick={()=>{setModal("action",false)}}
            >
              <CloseIcon fontSize="medium" style={{ color: "#043077" }} />
            </Grid>
            <SearchBar
            value={value}
            handleSideBarSubmit={handleSideBarSubmitAction}
            handleSideBarChange={handleSideBarChange}
            companies={companies}
            templates={templates}
            inspections={inspections}
            sites={sites}
            packageDetails={packageDetails}
            btnLoader={btnLoader}
            setBtnLoader={setBtnLoader}
          />
          </React.Fragment>
        </Dialog>
        <Grid item xs={12} md={12}>
        <TabBar active={"action"} setModal={setModal}/>
  
          <Action
            handleSideBarSubmitAction={handleSideBarSubmitAction}
            actionTableData={actionTableData}
            handlePdfDownload={handlePdfDownload}
            setDownloadIndex={setDownloadIndex}
            downloadIndex={downloadIndex}
          />
        </Grid>
        
      </Grid>
      </div>
    );
  } else {
    return <Spinner />;
  }
}

const Action = ({
  handleSideBarSubmitAction,
  actionTableData,
  handlePdfDownload,
  setDownloadIndex,
  downloadIndex,
}) => {
  const {t} = useTranslation()
  const [filterType, setFilterType] = React.useState("");
  const [view, setView] = React.useState("All Actions");
  const [action, setAction] = React.useState(false);
  const color1=`rgb(85,206,199)`;
  const color2=`rgb(22,103,219)`;
  // React.useEffect(() => {
  //   handleSideBarSubmitAction(view === "My Actions" ? true : false);
  // }, []);

  const toggleAction = (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setAction(!action);
    handleSideBarSubmitAction()
  };
  const classes = useStyles();
  return <div style={{ position: "relative", backgroundColor: "transparent", width: "100%", marginTop: "12px" }}>
      <Card variant="outlined" style={{ borderRadius: 10, padding: 10, marginTop: "20px", backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }}>
        <Tooltip title={t("Represents the tabular data to view all actions, created by the login user or based on the action's current state. The call to action tab provides quick access to details and PDF inspection report download options.")}>
          <HelpOutlineIcon style={{ color: Color.globalColor8, cursor: "pointer", position: "absolute", right: 10, top: 10 }} />
        </Tooltip>

        {window.innerWidth > 700 && <Grid container style={{ padding: 0 }} justify="center">
            <Grid item xs={2} md={1}>
              <Paper style={{ maxHeight: 70, maxWidth: 100, margin: 5, padding: 0, color: "#fff", //backgroundColor: filterType == "To Do" ? "#043077" : "#25c2ed",
                  background: filterType == "To Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "To Do" ? "" : "To Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "To Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                  {t("To Do")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={3} md={1}>
              <Paper style={{ maxHeight: 70, maxWidth: 100, margin: 5, padding: 0, color: "#fff", background: filterType == "Open" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Open" ? "" : "Open")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "In Progress").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                  {t("In Progress")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={3} md={1}>
              <Paper style={{ maxHeight: 70, maxWidth: 100, margin: 5, padding: 0, color: "#fff", background: filterType == "Over Due" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Over Due" ? "" : "Over Due")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.due && new Date(v?.due).getTime() <= new Date().getTime()).length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                  {t("Over Due")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={2} md={1}>
              <Paper style={{ maxHeight: 70, maxWidth: 100, margin: 5, padding: 0, color: "#fff", background: filterType == "Complete" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Complete" ? "" : "Complete")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Complete").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                  {t("Complete")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item xs={2} md={1}>
              <Paper style={{ maxHeight: 70, maxWidth: 100, margin: 5, padding: 0, color: "#fff", background: filterType == "Can't Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Can't Do" ? "" : "Can't Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Can't Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" }}>
                  {t("Can't Do")}
                </Typography>
              </Paper>
            </Grid>
          </Grid>}

          {window.innerWidth > 500 && window.innerWidth <= 700 &&  <Grid container style={{ padding: 0 }} justify="center">
            <Grid item style={{width:"20%"}} >
              <Paper style={{  margin: 5, padding: 0, color: "#fff", //backgroundColor: filterType == "To Do" ? "#043077" : "#25c2ed",
                  background: filterType == "To Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "To Do" ? "" : "To Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "To Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center", fontSize:'12px' }}>
                  {t("To Do")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}} >
              <Paper style={{  margin: 5, padding: 0, color: "#fff", background: filterType == "Open" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Open" ? "" : "Open")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "In Progress").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'12px' }}>
                  {t("In Progress")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}}>
              <Paper style={{  margin: 5, padding: 0, color: "#fff", background: filterType == "Over Due" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Over Due" ? "" : "Over Due")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.due && new Date(v?.due).getTime() <= new Date().getTime()).length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'12px' }}>
                  {t("Over Due")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item  style={{width:"20%"}}>
              <Paper style={{  margin: 5, padding: 0, color: "#fff", background: filterType == "Complete" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Complete" ? "" : "Complete")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Complete").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'12px' }}>
                  {t("Complete")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}}>
              <Paper style={{ margin: 5, padding: 0, color: "#fff", background: filterType == "Can't Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Can't Do" ? "" : "Can't Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Can't Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'12px' }}>
                  {t("Can't Do")}
                </Typography>
              </Paper>
            </Grid>
          </Grid>}

          {window.innerWidth <= 500 && <Grid container style={{ padding: 0 }} justify="center">
          <Grid item style={{width:"20%"}} >
              <Paper style={{  margin: 2, padding: 0, color: "#fff", //backgroundColor: filterType == "To Do" ? "#043077" : "#25c2ed",
                  background: filterType == "To Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "To Do" ? "" : "To Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "To Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center" ,fontSize:'10px'}}>
                  {typeof("To Do")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}} >
              <Paper style={{  margin: 2, padding: 0, color: "#fff", background: filterType == "Open" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Open" ? "" : "Open")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "In Progress").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'10px' }}>
                  {t("In Progress")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}}>
              <Paper style={{  margin: 2, padding: 0, color: "#fff", background: filterType == "Over Due" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Over Due" ? "" : "Over Due")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.due && new Date(v?.due).getTime() <= new Date().getTime()).length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'10px' }}>
                  {t("Over Due")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item  style={{width:"20%"}}>
              <Paper style={{  margin: 2, padding: 0, color: "#fff", background: filterType == "Complete" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Complete" ? "" : "Complete")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Complete").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'10px' }}>
                  {t("Complete")}
                </Typography>
              </Paper>
            </Grid>
            <Grid item style={{width:"20%"}}>
              <Paper style={{ margin: 2, padding: 0, color: "#fff", background: filterType == "Can't Do" ? "#043077" : `linear-gradient(#01defe, #1459f3)` }} className="cursor new-hover" onClick={() => setFilterType(filterType == "Can't Do" ? "" : "Can't Do")}>
                <Typography variant="h6" style={{ textAlign: "center", padding: 0 }}>
                  {actionTableData.filter((v) => v?.status === "Can't Do").length}
                </Typography>
                <Typography variant="subtitle1" style={{ textAlign: "center",fontSize:'10px' }}>
                  {t("Can't Do")}
                </Typography>
              </Paper>
            </Grid>
          </Grid>}
      </Card>

      <Grid container>
        <Grid item xs={12}>
          <Paper className="scrollbarShow2" style={{ overflow: "auto", padding: 0, marginTop: "20px", borderRadius: 10, height: window.innerHeight * 0.50, overflow: "auto", backgroundColor: "white", boxShadow: " 0 1px 2px 0 rgba(1, 128, 141, 0.2), 0 1px 5px 0 rgba(1, 1, 141, 0.19)" }} variant="outlined">
            <Table stickyHeader aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Title")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Site")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Created At")}{" "}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Status")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Assignees")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Priority")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Due Date")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Delayed By")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Action")}
                  </TableCell>
                  <TableCell
                    style={{
                      paddingTop: "10px",
                      padding: "10px",
                      fontWeight: "bold",
                      color: Color.globalColor8,
                      textTransform: "capitalize",
                    }}
                  >
                    {t("Download")}
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {actionTableData
                  .filter((v) =>
                    filterType === "Open"
                      ? v?.status === "In Progress"
                      : true && filterType === "To Do"
                      ? v?.status === "To Do"
                      : true && filterType === "Can't Do"
                      ? v?.status === "Can't Do"
                      : true && filterType === "Over Due"
                      ? v?.due &&
                        new Date(v?.due).getTime() <= new Date().getTime()
                      : true && filterType === "Complete"
                      ? v?.status === "Complete"
                      : true
                  )
                  .map((v, i) => {
                    console.log("TERST",v)
                    if(v?.isDeleted == false) {
                      return <TableRow>
                      <TableCell style={{ textAlign: "left", padding:"10px" }}>
                        <Tooltip title={v?.title}>
                          <div>
                            {v?.title?.slice(0, 10) +
                              (v?.title?.length > 10 ? "..." : "")}
                          </div>
                        </Tooltip>
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                      {v?.Site && <Tooltip title={v?.Site?.title}>
                          <div>
                            {v?.Site?.title?.slice(0, 10) +
                              (v?.Site?.title?.length > 10 ? "..." : "")}
                          </div>
                        </Tooltip>}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {moment(new Date(v?.createdAt)).format(
                          "DD MM yyyy"
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {v?.status === "active" ? "Inprogress" : v?.status}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {v?.User
                          ? v?.User?.first_name + " " + v?.User?.last_name
                          : ""}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {v?.priority}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {v?.due
                          ? moment(new Date(v?.due)).format(
                              "DD MM yyyy hh:mm"
                            )
                          : "-"}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"10px" }}>
                        {v?.due && v?.status === "Complete"
                          ? Math.abs(
                              moment(
                                new Date(
                                  v?.due ? v?.due : new Date()
                                ).getTime()
                              ).diff(new Date().getTime(), "days")
                            ) + " days"
                          : "0 days"}
                      </TableCell>
                      <TableCell style={{ textAlign: "left",padding:"5px" }}>
                        <Button className="addBtn" style={{ fontSize: 12, paddingLeft: 10, paddingRight: 10, height: 30, marginTop: -10, marginBottom: -10 }} onClick={() => setAction(v)}>
                          {t("Action")}
                        </Button>
                      </TableCell>
                      <TableCell align="left" style={{padding:'5px'}}>
                        {/* <DarkButton
                          style={{fontSize:12,paddingLeft:10,paddingRight:10,height:30,marginTop:-10,marginBottom:-10}}
                          onClick={() => {
                            setDownloadIndex(i);
                            handlePdfDownload(v?.inspection_id);
                          }}
                          disabled={
                            v?.inspection_id === null || downloadIndex != null
                          }
                        >
                          {downloadIndex == i ? "Downloading..." : "Download"}
                        </DarkButton> */}

                        <Button variant="contained" type="submit" className="addBtn" component="span" style={{ fontSize: 12, paddingLeft: 10, paddingRight: 10, height: 30, marginTop: -10, marginBottom: -10 }} onClick={() => {
                            setDownloadIndex(i);
                            console.log(v)
                            handlePdfDownload(v?.inspection_id, v?.Inspection?.isCompleted,v?.Inspection?.pdf_url);
                          }} disabled={v?.inspection_id === null || downloadIndex != null}>
                          {downloadIndex == i ? <>{t("Downloading...")}</> : <>{t("Download")}</>}
                        </Button>
                      </TableCell>
                    </TableRow>;
                    }              
                    
                  })}
              </TableBody>
            </Table>
          </Paper>
        </Grid>
      </Grid>
      <InspectionAction toggleAction={toggleAction} state={action} />
    </div>;
};

const useStyles = makeStyles((theme) => ({
  paperCont: {
    width: "70%",
    height: "100%",

    padding: 5,
  },
  paper: {
    backgroundColor: theme.palette.background.paper,

    padding: 1,
  },
}));

function ModalContainer({ setModal, modal }) {
  const classes = useStyles();
  const {t} = useTranslation();
    // getModalStyle is not a pure function, we roll the style only on the first render
  // const [modalStyle] = React.useState(getModalStyle);
  return (
    <Dialog
      open={modal !== false}
      onClose={() => setModal(false)}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      style={{ border: "none" }}
      fullWidth
      maxWidth="md"
    >
      {modal !== false && (
        <div className={classes.paper}>
          <Typography variant="h6">Audit Details</Typography>

          <Paper
            style={{ padding: 5, backgroundColor: "#f0f2f5" }}
            elevation={0}
          >
            <Grid container>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={3}>
                    Location:
                  </Grid>
                  <Grid item>{modal[0]?.site_title}</Grid>
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Grid container>
                  <Grid item xs={3}>
                    Audit Name:
                  </Grid>
                  <Grid item>{modal[0]?.title}</Grid>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell style={{ minWidth: 150 }}>Inspector</TableCell>
                {/* <TableCell style={{ minWidth: 150 }}>Person Seen</TableCell> */}
                <TableCell style={{ minWidth: 150 }}>Date</TableCell>
                <TableCell style={{ minWidth: 120 }}>Start Time</TableCell>
                <TableCell style={{ minWidth: 120 }}>End Time</TableCell>
                <TableCell style={{ minWidth: 100 }}>Score</TableCell>
                <TableCell style={{ minWidth: 100 }}>Status</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {modal?.map((v, i) => {
                return (
                  <TableRow key={i}>
                    <TableCell>{v?.user}</TableCell>
                    {/* <TableCell /> */}
                    <TableCell>{v?.date}</TableCell>
                    <TableCell>{v?.start_time}</TableCell>
                    <TableCell>{v?.end_time}</TableCell>
                    <TableCell>{v?.score.toFixed()}</TableCell>
                    <TableCell>
                      {v?.score <= 99 ? "Incomplete" : "Complete"}
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </div>
      )}
    </Dialog>
  );
}

// const DashboardSidebar = ({
//   value,
//   handleSideBarChange,
//   handleSideBarSubmit,
//   templates,
//   inspections,
//   sites,
//   packageDetails,
// }) => {
//   return (
//     <Paper
//       style={
//         {
//           // height: "98vh",
//           // overflow: "hidden",
//           // overflowY: "scroll",
//         }
//       }
//     >
//       <Typography
//         style={{ backgroundColor: "#043077", padding: 9, color: "white" }}
//         variant="h6"
//       >
//         Advanced Search
//       </Typography>
//       <br />
//       <div style={{ margin: 5 }}>
//         <p className="mp-0">From</p>
//         <MuiPickersUtilsProvider utils={DateFnsUtils}>
//           <KeyboardDatePicker
//             inputVariant="outlined"
//             id="outlined-basic"
//             format="MM/dd/yyyy"
//             value={value.from}
//             onChange={(e) =>
//               handleSideBarChange({ target: { name: "from", value: e } })
//             }
//             KeyboardButtonProps={{
//               "aria-label": "change date",
//             }}
//             fullWidth
//             minDate={
//               packageDetails.status == "no"
//                 ? new Date(
//                     new Date(new Date().getFullYear(), new Date().getMonth(), 1)
//                   )
//                 : null
//             }
//             maxDate={
//               packageDetails.status == "no"
//                 ? new Date(packageDetails.end_date)
//                 : null
//             }
//           />
//         </MuiPickersUtilsProvider>
//       </div>

//       <div style={{ margin: 5 }}>
//         <p className="mp-0">End</p>
//         <MuiPickersUtilsProvider utils={DateFnsUtils}>
//           <KeyboardDatePicker
//             inputVariant="outlined"
//             id="outlined-basic"
//             format="MM/dd/yyyy"
//             value={value.end}
//             onChange={(e) =>
//               handleSideBarChange({ target: { name: "end", value: e } })
//             }
//             KeyboardButtonProps={{
//               "aria-label": "change date",
//             }}
//             fullWidth
//           />
//         </MuiPickersUtilsProvider>
//       </div>
//       <div style={{ margin: 5 }}>
//         <Autocomplete
//           options={templates}
//           fullWidth
//           autoComplete='off'
//           getOptionLabel={(option) => option.title}
//           renderOption={(option) => (
//             <React.Fragment>{option.title}</React.Fragment>
//           )}
//           onChange={(e, value) =>
//             handleSideBarChange({
//               target: { name: "template_id", value: value },
//             })
//           }
//           value={value.template_id}
//           style={{ width: "100%" }}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               // variant="outlined"
//               label="Templates"
//               style={{ minWidth: 200 }}
//               inputProps={{
//                 ...params.inputProps,
//                 // autoComplete: "new-password", // disable autocomplete and autofill
//               }}
//             />
//           )}
//         />
//       </div>

//       <div style={{ margin: 5 }}>
//         <Autocomplete
//           options={inspections.filter((v) =>
//             value.template_id?.id
//               ? v?.template_id === value.template_id?.id
//               : true
//           )}
//           fullWidth
//           getOptionLabel={(option) => option.title}
//           renderOption={(option) => (
//             <React.Fragment>{option.title}</React.Fragment>
//           )}
//           value={value.schedule_id}
//           onChange={(e, value) =>
//             handleSideBarChange({
//               target: { name: "schedule_id", value: value },
//             })
//           }
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               // variant="outlined"
//               label="Inspections"
//               inputProps={{
//                 ...params.inputProps,
//                 // autoComplete: "new-password", // disable autocomplete and autofill
//               }}
//             />
//           )}
//         />
//       </div>

//       <div style={{ margin: 5 }}>
//         <Autocomplete
//           options={sites}
//           fullWidth
//           getOptionLabel={(option) => option.title}
//           renderOption={(option) => (
//             <React.Fragment>{option.title}</React.Fragment>
//           )}
//           onChange={(e, value) =>
//             handleSideBarChange({
//               target: { name: "site_id", value: value },
//             })
//           }
//           value={value.site_id}
//           renderInput={(params) => (
//             <TextField
//               {...params}
//               // variant="outlined"
//               label="Sites"
//               inputProps={{
//                 ...params.inputProps,
//                 // autoComplete: "new-password", // disable autocomplete and autofill
//               }}
//             />
//           )}
//         />
//       </div>

//       <div style={{ margin: 5 }}>
//         <Button
//           variant="contained"
//           color="primary"
//           className="addBtn"
//           fullWidth
//           onClick={() => handleSideBarSubmit(null)}
//           style={{ backgroundColor: "#043077" }}
//         >
//           Apply
//         </Button>

        
//       </div>
//     </Paper>
//   );
// };
